import PermissionSearchList from './PermissionSearchList';

export default PermissionSearchList;
